import * as React from "react";
import { makeStyles, shorthands, Button, Text, Title2 } from "@fluentui/react-components";

import promo1 from './Assets/promo/promo1.png';
import promo2 from './Assets/promo/promo2.png';
import promo3 from './Assets/promo/promo3.png';
import promo4 from './Assets/promo/promo4.png';

const useStyles = makeStyles({
  main: {
    display: "grid",
    // 3 equal columns by default
    gridTemplateColumns: "1fr 1fr 1fr",
    ...shorthands.gap("16px"),
    padding: "16px",
    alignItems: "stretch",
    height: "calc(100vh - 120px)",
    overflowY: "auto",

    // Example responsive breakpoints:
    "@media (max-width: 1200px)": {
      "&": {
        // Switch to 2 columns when narrower
        gridTemplateColumns: "2fr 1fr",
      },
    },
    "@media (max-width: 700px)": {
      "&": {
        // Stacked layout on small screens
        display: "flex",
        flexDirection: "column",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "auto auto",
        rowGap: "16px",
      },
    },
  },

  // Column 1: single tall image
  col1: {
    display: "flex",
    flexDirection: "column",
  },

  // Column 2: two stacked images (50/50)
  col2: {
    display: "grid",
    gridTemplateRows: "1fr 1fr",
    ...shorthands.gap("16px"),
  },

  // Column 3: top is 3/4 for image, bottom 1/4 for CTA
  col3: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("16px"),
    height: "100%",
  },
  threeQuarter: {
    flex: 3,
    display: "flex",
    position: "relative",
  },
  quarter: {
    flex: 1,
    display: "flex",
    flexDirection: "column", // Stack children vertically
    alignItems: "center",
    justifyContent: "center",
    ...shorthands.gap("8px"), // Optional: adds spacing between elements
  },

  // Shared image + overlay styling
  imageContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    display: "flex",

    // Reveal overlay on hover
    "&:hover .overlay": {
      opacity: 1,
    },

    // Nested <img> styles
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "opacity 0.3s ease",
    padding: "16px",
    color: "black",
  },
});

const PromoPage = () => {
  const styles = useStyles();

  return (
    <div className={styles.main}>
      {/* Column 1 */}
      <div className={styles.col1}>
        <div className={styles.imageContainer}>
          <img
            src={promo1}
            alt="Product 1"
          />
          <div className={`${styles.overlay} overlay`}>
          <Text>Migrate
Transform your workspace with unmatched speed and confidence
Automate application discovery and modernization to accelerate your digital transformation journey. Our intelligent platform helps you seamlessly transition to modern environments without compromising business continuity.
Key capabilities:
•	Baseline Discovery - Automatically capture and analyze your current application estate
•	Windows 10 → Windows 11 - Ensure compatibility and smooth transitions
•	Citrix → AVD / Windows 365 - Modernize your virtual environment
•	SCCM → Intune - Streamline your journey to cloud-based management</Text>

          </div>
        </div>
      </div>

      {/* Column 2 (two stacked images) */}
      <div className={styles.col2}>
        <div className={styles.imageContainer}>
          <img
            src={promo2}
            alt="Product 2"
          />
          <div className={`${styles.overlay} overlay`}>
          <Text>Intune Migration
We understand that application migration to Intune is the last mile for many organizations with complex environments. 
Let WorkspaceDNA simplify application complexity in your Intune migration. WorkspaceDNA software automates:
•	SCCM application import, including:
o	Metadata
o	Icon
o	Application dependencies
o	Detection rules
•	import of third-party application updates
•	validation of applications against the enterprise’s specific environment(s)
•	export of applications to Intune - ready for deployment.</Text>

          </div>
        </div>
        <div className={styles.imageContainer}>
          <img
            src={promo3}
            alt="Product 3"
          />
          <div className={`${styles.overlay} overlay`}>
          <Text>Manage
The power of foresight in workspace management
Stay ahead of change with intelligent automation that proactively tests, validates and deploys applications across your environment. Transform from reactive to predictive workspace management.
Key capabilities:
•	3rd-Party App Patching - Automatically test and deploy security updates
•	Intune Optimization - Enhance your modern management experience
•	Validate Custom Builds - Ensure compatibility across your environment
•	Security Remediation - Proactively address vulnerabilities
</Text>
          </div>
        </div>
      </div>

      {/* Column 3 (3/4 image + 1/4 CTA) */}
      <div className={styles.col3}>
        <div className={styles.threeQuarter}>
          <div className={styles.imageContainer}>
            <img
              src={promo4}
              alt="Product 4"
            />
            <div className={`${styles.overlay} overlay`}>
                <Text><Text weight="bold">Installing Confidence</Text><br /><br />
                  The WorkspaceDNA platform offers a unified approach to workspaces that are Future-Ready Fast and eliminates impossible choices:<br /><br />
                  • Fast- Deploy applications at scale with speed and confidence<br />
                  • Predictive - Understand application behavior and compatibility before issues arise<br />
                  • Intelligent - Automated Discovery, validation and management
                </Text>
            </div>
          </div>
        </div>
        <div className={styles.quarter}>
          <Title2>Interested in seeing more?</Title2>
          <Button as="a" appearance='primary' size="medium" href="https://workspacedna.com/request-demo" target="_blank">Book a demo!</Button>
        </div>
      </div>
    </div>
  );
};

export default PromoPage;